import { Pipe, PipeTransform } from '@angular/core';
import { DataObject } from '@app/_shared/interfaces';
import { OrderStatus } from '@app/_shared/interfaces/http/order-status';

@Pipe({
  name: 'orderStatusTitle',
  standalone: false, // eslint-disable-line
})
export class OrderStatusTitlePipe implements PipeTransform {
  transform(id: string, states: DataObject<OrderStatus>[]): string {
    if (!id) {
      return '';
    }

    if (!states || !states.length) {
      return id;
    }

    const state = states.find((state) => state.id === id);
    return state ? state.attributes.title : 'Id: ' + id;
  }
}
